import { render, staticRenderFns } from "./u-tit-wrap-underline.vue?vue&type=template&id=f895aa4c&scoped=true&"
import script from "./u-tit-wrap-underline.vue?vue&type=script&lang=js&"
export * from "./u-tit-wrap-underline.vue?vue&type=script&lang=js&"
import style0 from "./u-tit-wrap-underline.vue?vue&type=style&index=0&id=f895aa4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f895aa4c",
  null
  
)

export default component.exports